module.exports = __webpack_public_path__ + "static/media/fvs-logo.c96aa32b.png";